module.exports = __webpack_public_path__ + "img/leadership_team.a700667d.png";